import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { TrustpilotMiniWidgetComponent } from '../../../app/content/layout/components/atoms/trustpilot-mini-widget/trustpilot-mini-widget.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<TrustpilotMiniWidgetComponent> = {
  title: 'Atoms/Trustpilot/Mini Widget',
  component: TrustpilotMiniWidgetComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<TrustpilotMiniWidgetComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-trustpilot-mini-widget')).toBeTruthy();
  },
};
